import baseProps from "@/base_lib/data/props/base"

const tooltipButtonProps = {
    ...baseProps,
    label: {
        type: String,
        required: true,
    },
}

export default tooltipButtonProps
